module.exports = __webpack_public_path__ + "img/pr-12.c6e0eb87.png";